import { httpClient } from '../http/httpClient'

export type GetChartLinkResponse = {
  total: number
  data: {
    date: string
    count: number
  }[]
}

export const getChartLink = async (linkId: string) => {
  const { data } = await httpClient
    .get<GetChartLinkResponse>(`/self-hire/chart/${linkId}`)
    .catch((error) => {
      throw error?.response?.data || error
    })
  return data
}
